import { render, staticRenderFns } from "./addturntable.vue?vue&type=template&id=8194540a&scoped=true"
import script from "./addturntable.vue?vue&type=script&lang=js"
export * from "./addturntable.vue?vue&type=script&lang=js"
import style0 from "./addturntable.vue?vue&type=style&index=0&id=8194540a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8194540a",
  null
  
)

export default component.exports